import React from 'react'
import skeletonStyle from '../style/BusinessInfoSkeleton.module.css';
const BusinessInfoSkeleton = () => {
    return (
        <>
            <div className={`${skeletonStyle.businessSkeletonCard}`}>
                <div className={`${skeletonStyle.skeleton} ${skeletonStyle.logo}`}></div>
                <div className={`${skeletonStyle.skeletonInfo}`}>
                    <div className={`${skeletonStyle.skeleton} ${skeletonStyle.businessName}`}></div>
                    <div className={`${skeletonStyle.skeleton} ${skeletonStyle.businessId}`}></div>
                    <div className={`${skeletonStyle.skeleton} ${skeletonStyle.email}`}></div>
                    <div className="row">
                        <div className='col-md-6'>
                            <div className={`${skeletonStyle.skeletonBox} w-100`}>
                                <div className={`${skeletonStyle.skeleton} ${skeletonStyle.label} mb-5`}></div>
                                <div className={`${skeletonStyle.skeleton} ${skeletonStyle.address}`}></div>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className={`${skeletonStyle.skeletonBox} w-100`}>
                                <div className='d-flex mb-5'>
                                    <div className={`${skeletonStyle.skeleton} ${skeletonStyle.label}`}></div>
                                    <div className={`${skeletonStyle.skeleton} ${skeletonStyle.label} m-auto`}></div>
                                </div>
                                <div className='d-flex'>
                                    <div className={`${skeletonStyle.skeleton} ${skeletonStyle.label}`}></div>
                                    <div className={`${skeletonStyle.skeleton} ${skeletonStyle.label} m-auto`}></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`${skeletonStyle.skeleton} ${skeletonStyle.editIcon}`}></div>
            </div>
        </>
    )
}

export default BusinessInfoSkeleton